import { render } from "./InternalLBAssignedVmTab.vue?vue&type=template&id=3a7b0fc6"
import script from "./InternalLBAssignedVmTab.vue?vue&type=script&lang=js"
export * from "./InternalLBAssignedVmTab.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__